import React from 'react';
import { Tabbles } from '../../components';
import { PiUserCircle } from 'react-icons/pi';
import { useSelector } from 'react-redux';
import { LuFileSearch2 } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

const AppointmentHistory = ({ loginData }) => {
    const { t } = useTranslation();
    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );

    return (<Tabbles.TableBlk
        headerIcon={
            <PiUserCircle
                className="header-Icn"

            />
        }
        heading={t("patient_Details.appointment_history.appointment_history")}
        columns={[
            `${t("booking_id")}`,
            `${t("specialist_name")}`,
            `${t("medical_specialty")}`,
            `${t("time_&_date")}`,
            `${t("location")}`,
            loginData?.currencyCode,
            `${t("Diagnosis")}`,
        ]}
        data={getAppointmentsData?.result?.patientAppointments?.map((appointment) => ({

            [t("booking_id")]: appointment.bookingId,
            [t("specialist_name")]: appointment.doctorFirstName + " " + appointment.doctorLastName,
            [t("medical_specialty")]: appointment.physicianServices,
            [t("time_&_date")]: (
                <>
                    <div>
                        {new Date(appointment.appointmentDateTime).toLocaleTimeString(
                            "en-US",
                            {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            }
                        )}
                    </div>
                    <div>
                        {new Date(appointment.appointmentDateTime)
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, " - ")}
                    </div>
                </>
            ),
            [t("location")]: appointment.appointmentType,
            [loginData?.currencyCode]: appointment.amount + " " + appointment.doctorCurrency,
            [t("Diagnosis")]: (
                <div className="editBlkIcon">
                    <LuFileSearch2
                        // onClick={() =>
                        //     navigate(
                        //         `/doctor/diagnostic-report/patient-information-and-symptoms/${appointment.patientFirstName.replace(
                        //             /\s+/g,
                        //             "-"
                        //         )}-${appointment.patientLastName.replace(/\s+/g, "-")}`,
                        //         {
                        //             state: {
                        //                 appointment,
                        //                 appointmentStatus: 4,
                        //             },
                        //         }
                        //     )
                        // }
                        className="editIcon"
                    />
                </div>
            ),

        }))}
        tabbleClassname="tabble"
    />)
}

export default AppointmentHistory;
